<template>
    <div class="dtcup-main">
        <div class="content">
            <div class="logo"></div>
            <base-header :name="user_name" :topOnly="flag_top" :showOnly="flag_top" :account_list="account_list"></base-header>
            <div class="logout" v-if="is_pc && user_name" @click="log_out()">退出登录</div>
            <div class="danmu">
                <p>此处应有掌声</p>
                <p>wo shi 09 wo zhong</p>
                <p>对不起，这场比赛我要赢！</p>
                <p>ji ba yang?</p>
            </div>
            <div class="part">
                <div class="part-content">
                    <p class="p1">- Dota 6.83 / Dota 6.88 -</p>
                    <p class="p2">总奖金：伍拾万元</p>
                    <div class="money"></div>
                    <p class="p3">比赛时间：2024.3.6 - 4.7</p>
                    <div class="toast"></div>
                    <p class="p4">特邀各路明星选手，我们的青春回来了!</p>
                    <p class="p5" v-if="!is_sign">报名截止：3月4日</p>
                    <div :class="`apply-btn ${is_sign?'over':'end'}`" @click="getPermission()"></div>
                    <div class="part-tip">
                        <span @click="pop_show='bonus'">奖金分配</span>
                        <span @click="pop_show='schedule'">赛事详情</span>
                    </div>
                </div>
            </div>

            <div class="mate-info"></div>

            <div class="mark" v-if="pop_show"></div>
        </div>
        <div :class="`pop ${pop_show}`" v-if="pop_show">
            <div class="tite">{{ pop_show=='apply'||pop_show=='role'?'比赛报名':pop_show=='schedule'?'赛程安排':'奖金分配'}}</div>
            <div class="tips" v-if="pop_show=='bonus'">总奖金：500000元</div>
            <div class="tips1" v-if="pop_show=='apply' && is_sign">{{map_type==1?'6.83项目比赛':map_type==2?'6.88项目比赛':''}}</div>
            <div class="close" @click="close_pop()"></div>
            <div class="inner">
                <!-- 赛程安排 -->
                <div v-if="pop_show=='schedule'">
                    <p>
                        <span>小组赛</span>
                    </p>
                    <p>2024/3/6 -- 3/17，12天</p>
                    <p>(6.83、6.88两个比赛项目同时进行)</p>
                    <p>
                        <span>双败淘汰赛：</span>
                    </p>
                    <p>6.83项目：2024/3/21 -- 3/24，4天</p>
                    <p>6.88项目：2024/3/28 -- 3/31，4天</p>
                    <p>
                        <span>OMG冠军邀请赛：</span>
                    </p>
                    <p>2024/4/6 -- 4/7，2天</p>
                    <p>(6.83、6.88两个项目冠亚军共计四支队伍获得邀请）</p>
                </div>
                <!-- 奖金分配 -->
                <div v-if="pop_show=='bonus'">
                    <div class="money">
                        <ul class="tab-ul">
                            <li :class="`tab-li ${tab==1?'selected':''}`" @click="tab=1">DOTA6.83</li>
                            <li :class="`tab-li ${tab==2?'selected':''}`" @click="tab=2">DOTA6.88</li>
                        </ul>
                        <p class="p1">奖金合计：{{tab==1?150000:250000}}元</p>
                        <table class="money-info">
                            <tr v-for="(item, index) in bonus_list" :key="index">
                                <td>{{`第${item.rank}名`}}</td>
                                <td>{{`${tab==1?item.money1:item.money2}元`}}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="info">
                        <h1>OMG冠军邀请赛</h1>
                        <p>6.83及6.88两个项目冠亚军共计四支队伍</p>
                        <p><span>6局比赛，每局奖金1万，合计6万</span></p>
                    </div>
                    <p>以上奖金为名次队伍获得的税前金额，最终发放到每个队员</p>
                    <p>
                        <span>锦鲤奖：投票观众中抽出10个千元奖励</span>
                    </p>
                    <p style="margin-bottom:.2rem">
                        其它综合奖励3万
                    </p>
                </div>
                <!-- 报名 -->
                <div v-if="pop_show=='apply'">
                    <p class="tt">我的信息{{role==1?'（队长）':role==2?'（队员）':''}}</p>
                    <base-input :title="`比赛昵称：`" style="margin-top: .2rem" v-model="game_name" :readonly="true" :placeholder="`请输入比赛昵称`" class="input-box"></base-input>
                    <base-input :title="`手机：`" v-model="phone" @blur="checkPhone" :readonly="is_sign" class="input-box" :placeholder="`请输入手机号`"></base-input>
                    <base-input :title="`邮箱：`" v-model="email" @blur="checkEmail" :readonly="is_sign" class="input-box" :placeholder="`请输入邮箱地址`"></base-input>
                    <p class="tt">队伍信息
                        <span class="type" v-if="!is_sign && role == 1">
                            <ul class="tab-ul">
                                <li :class="`tab-li ${map_type==1?'selected':''}`" @click="map_type=1">
                                    <div class="icon"></div>
                                    6.83项目比赛
                                </li>
                                 <li :class="`tab-li ${map_type==2?'selected':''}`" @click="map_type=2">
                                    <div class="icon"></div>
                                    6.88项目比赛
                                </li>
                            </ul>
                        </span>
                        <span class="psw" v-if="is_sign && role==1">
                            队伍密码：<em>{{psw}}</em>
                            <!-- <div class="btn" @click="changePsw()"></div> -->
                        </span>
                        <!-- <span class="dismiss" v-if="is_sign && role==1">
                            <div class="dismiss-btn" @click="dismiss()">解散队伍</div>
                        </span> -->
                    </p>
                    <base-input :title="`队名：`" v-model="team_name" @blur="checkNickname($event, 2)" :placeholder="`请输入队伍名称`" :readonly="is_sign" class="input-box"></base-input>
                    <base-input :title="`队伍密码：`" v-if="!is_sign" v-model="psw" @blur="checkPassword($event)"  :placeholder="`请输入队伍4位数字密码`"  :readonly="is_sign" class="input-box"></base-input>
                   
                    <div class="players" v-if="is_sign">
                        <div class="player-box" v-for="(item, index) in teams" :key="index">
                            <base-input :title="`${index==0?'队长':'队员'+(index)}昵称：`" v-model="item.game_name" :readonly="is_sign" 
                                :class="`input-box ${item.game_name==game_name?'own':''}`"></base-input>
                            <!-- <div class="remove-btn" @click="removePlayer(item)" v-if="index>0 && item.user_id!=user_id && role==1"></div> -->
                        </div>
                    </div>

                    <div class="login-err" v-if="!is_sign">{{err}}</div>
                    <div class="rules">
                        <div :class="`tick ${is_sign || is_agree?'ticked':''}`" @click="agreeFunc()" v-if="!is_sign&&is_agree"></div>
                        <p>
                            {{is_sign||is_agree?'我已阅读并同意':'请点击阅读并同意'}}
                            <span @click="popup_show = 1" :class="`${is_sign?'over':''}`">《09平台龙虎杯参赛者协议》</span>
                        </p>
                    </div>
                    <div class="submit-btn" @click="submit" v-if="!is_sign"></div>
                </div>

                <!-- 报名角色确认 -->
                <div v-if="pop_show == 'role'">
                    <div class="role-btn" @click="role=1;pop_show='apply'"></div>
                    <p>去创建队伍，等待其它队员加入</p>
                    <div class="role-btn role2" @click="role=2;pop_show='apply'"></div>
                    <p>去加入别人已经创建的队伍</p>
                </div>
            </div>
        </div>
        <div class="pop pop1 agree-box" v-if="popup_show">
            <div class="tite">09平台龙虎杯参赛者协议</div>
            <div class="close" @click="popup_show = 0"></div>
            <div class="inner">
                <p>“2024年第【一】届【09平台龙虎杯】赛”（以下简称“大赛”）是由【上海四游网络科技有限公司】公司（以下简称“主办方”）举办的【09平台龙虎杯】大赛。在参赛之前，您务必确认您（以下另称为“参赛者”）已审慎阅读、充分理解《【09平台龙虎杯】参赛协议》（下称“本协议”）的内容，并且同意遵守相关规则。</p>
                <p>
                    <span>第一条 参赛资格和大赛内容</span>
                </p>
                <p>1、您需年满18周岁或达到您所在地区的法定成年年龄，具备完全的民事权利能力和民事行为能力，并以实名制注册方式报名参赛。</p>
                <p><i>2、凡出现下列任一情形的，您将被取消参赛资格：</i></p>
                <p>（1）弄虚作假（包括但不限于提供虚假材料、使用他人身份参赛或允许他人使用自己身份参赛、无故弃赛、操纵或控制比赛结果等）或存在违反本协议、违反相关法律法规的行为的。</p>
                <p>（2）侵犯主办方或第三人的包括不限于知识产权和人格权等一切合法权利的。</p>
                <p>（3）在比赛中进行任何以下性质的行为：危害国家安全、违背社会公序良俗、虚假、诽谤、侵权、有害、色情、攻击、欺侮、骚扰、丑闻、仇恨、煽动、威胁、亵渎、淫秽、迷信、侵犯隐私或在其他方面令人反感，包括但不限于助长违法活动、存在明显性描述、宣扬暴力，以及任何歧视性的、违法的、造成或可能造成人身财产损失或伤害、可能引起适用法律下的民事或刑事责任的内容和行为。</p>
                <p>（4）有其他违反大赛竞赛规则的行为。《大赛竞赛规则》会符合国家体育总局制定的电子竞技运动相关规范，在公平、公正的前提下制订并在赛事过程中进行修正，同时会在比赛群里面公告。</p>
                <p>3、大赛内容：本届《09平台龙虎杯》包含Dota6.83、Dota6.88、OMG冠军邀请赛三个项目，详细赛程及奖金获取方式依据报名页名、比赛专题页面、比赛群公布</p>
                <p>4、大赛时间：【2024】年【3】月【6】日至【2024】年【4】月【7】日</p>
                <p>
                    <span>第二条 责任与义务</span>
                </p>
                <p><i>1、一旦参赛将视为参赛者同意并遵守大赛竞赛规则、比赛相关说明及规定，若参赛者发生违反上述规则、说明或规定行为的，自愿接受主办方的处理决定，如因此造成主办方或第三方损失的，参赛者需独立承担全部法律责任并赔偿主办方及其关联公司因此遭受的损失</i></p>
                <p><i>2、参赛者同意永久免费授予主办方（包括承办方、协办方，下同）对参赛作品、个人和队伍介绍在内的参赛信息、输出的相关照片及视频等用于市场宣传活动的权利及相关的知识产权，同意配合并授权主办方免费使用含参赛者肖像、声音、姓名等的图片、视频、文字等开展大赛宣传活动，由此产生的全部收益归主办方所有。参赛者承诺，向主办方提供的参赛作品、照片、视频、肖像、声音、姓名等信息均真实、合法、有效，且不侵犯主办方或任何第三方的知识产权、肖像权、姓名权、名誉权等合法权益，否则应承担由此造成的一切损失和责任，如造成主办方损失的，由参赛者承担赔偿责任。</i></p>
                <p><i>3、参赛者在参加本次比赛时不得有任何所有作弊行为，包括并不仅限于抄袭、虚假信息、盗用、以及本协议第一条第2款第（1）项的弄虚作假行为等，一经发现参赛成绩将被视为无效，并取消参赛队伍的参赛资格。</i></p>
                <p><i>4、参赛者需遵循主办方关于本次大赛的所有行程与安排，充分了解现场活动的潜在风险，妥善保管自身参加大赛的账号（用户名）和密码，自行注意自身的人身及财产安全。参赛者非因主办方原因受到损失的，主办方不承担责任。</i></p>
                <p>5、在本次参赛过程中，参赛者可能或获取到主办方（“披露方”）提供的保密
信息，包括但不限于商业秘密、商业计划、经营战略、文档模版、项目流程和商
业信息以及上述信息的衍生信息，参赛者承诺严格保守其所获知的保密信息，在
未事先取得披露方书面同意的情况下，不得向任何第三方披露。所有保密信息仅
能用于披露方制定的本次大赛相关项目，不得用于任何其他用途。比赛完成后或
应披露方要求时，参赛者承诺即时返还或销毁其所持有的任何形式的保密信息
（包括但不限于原件、复印件、复制品和概述摘要），并向披露方提供已经返还
或销毁的书面确认。</p>
                <p>
                    <em>6、参赛者同意配合主办方在指定的线上及线下渠道进行大赛的宣传，如需以上
述渠道以外的方式进行宣传或发布与比赛有关的信息的，应事先征得主办方的
书面同意。在本次大赛举办期间（即【2024】年【3】月【6】日至【2024】年
【4】月【7】日），参赛者在对外宣传或网络直播活动中，仅能播出其在赛事
主办方所在平台进行游玩或比赛的视频。</em>
                </p>
                <p><i>7、参赛者应积极维护主办方形象，不做出有损于主办方形象及损害主办方利益
的行为。参赛者不得通过任何渠道（包括但不限于网站、微博、微信或微信公
众号、网络直播等）发布不利于甲方的言论。</i></p>
<p><i>8、参赛者自行承担因参加大赛所获奖金（奖励）应缴纳的个人所得税，主办方
将依法予以代扣代缴。</i></p>
                <p>
                    <span>第三条 违约及赔偿</span>
                </p>
                <p>1、参赛者承诺并确认，若违反本协议项下的任何义务或责任，参赛者须向赛事
主办方支付违约金共计人民币【<i>15</i>】万元，若前述违约金不足弥补主办方损失，
则参赛者仍然应当就损失部分进行赔偿。</p>
<p>2、如参赛者被主办方扣除奖金（奖励）、给予处罚的，主办方有权自该参赛者
应得奖金（奖励）中予以扣除；如参赛者被取消参赛资格的，扣除全部奖金（奖
励）。对已领取的奖金（奖励），应按主办方要求限期予以退还。</p>
                <p>
                    <span>第四条 对本协议的修订</span>
                </p>
                <p>如果主办方将对本协议进行调整（包括重大变更等）且所述调整将对您的权利和
义务产生重大影响，主办方有权不定期调整本协议的内容并将通过适当的方式通
知您。我们建议您定期查看本协议，从而确保您了解主办方所做的任何此类调整。
如您在相关调整信息发布后，继续参加本次大赛，即视为您完全同意并接受主办
方的相关调整和更新，并愿意接受其法律约束。</p>
                <p>
                    <span>第五条 适用法律及管辖</span>
                </p>
                <p>本协议适用法律为中华人民共和国法律。<i>您同意，本协议签订地为上海市浦东新
区。在合同履行过程中双方如发生纠纷，应协商解决；协商不成的，双方应向
协议签订地有管辖权的人民法院以诉讼的方式解决。</i></p>
                <p>
                    <span>第六条 其他条款</span>
                </p>
                <p>1、本协议中的任何内容均不得视为在您与主办方之间建立了任何合作或代理关
系。任何一方无权以另一方的名义或代表另一方产生任何责任债务或成本，或订
立任何合同或其它约定。</p>
                <p>2、因主办方合理控制范围外的事件（包括但不限于水灾、火灾、地震、暴乱、
罢工、政府部门命令或管制要求、大规模流行性疾病、黑客攻击、通讯网络故障、
互联网带宽限制等不可抗力或意外事件）造成或导致主办方未能或延迟履行本协
议中的义务，主办方不承担任何责任。主办方有权转让、分包或更替主办方在本
协议下的权利和义务。</p>
                <p>3、若本协议中的任何条款被有管辖权的法院或其它任何主管机构视为无效、失
效或无法执行，则该条款应视为已从本协议中删除，但其它任何条款仍具有法律
效力。</p>
<p><i>4、如本协议未作规定的，以大赛竞赛规则、比赛相关说明及规定内容为准。</i></p>
<p><span>本人已仔细阅读上述协议的内容，清楚的理解协议条款及其含义，报名代表自
愿同意并接受上述协议条款。</span></p>
                <div class="agree-btn" @click="is_agree=true;popup_show=0" v-if="!is_sign"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { isToday, setEndTime } from '@/utils/common'
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url
const shop_url = baseUrls.shop_url
let hd_url = 'https://hd.09game.com/game/'
// hd_url = 'https://testuser.09game.com/game5052/'
// hd_url = 'http://192.168.1.140:5051/'

export default {
    name: 'dt_cup',
    data() {
        return {
            is_agree: false,
            popup_show: 0,
            is_sign: false, //是否报名
            flag_top: true,
            token: null,
            open_id: '',
            user_id: '',
            user_name: '',
            game_name: '',
            account_list: [],
            pop_show: '', //打开弹框的类型
            btn_lock: false, //防抖
            videoUrl: '', //预览地址
            videoName: '', //预览名称
            timer: null,
            user_info: {},
            err: '',
            email: '',
            phone: '',
            nickname: '',
            team_name: '', //队伍名称
            psw: '', //队伍密码
            teams: [],//队伍详细信息
            bonus_list: [
                { rank: 1, money1: 36000, money2: 60000 },
                { rank: 2, money1: 25500, money2: 42500 },
                { rank: 3, money1: 21000, money2: 35000 },
                { rank: 4, money1: 16500, money2: 27500 },
                { rank: 5, money1: 13500, money2: 22500 },
                { rank: 6, money1: 13500, money2: 22500 },
                { rank: 7, money1: 12000, money2: 20000 },
                { rank: 8, money1: 12000, money2: 20000 },
            ],
            is_pc: 0,
            role: 0, //1队长  2队员
            map_type: 0, //1：6.83；2：6.88
            tab: 1, //1：6.83；2：6.88
        }
    },
    mounted() {},
    // beforeRouteEnter(to, from, next) {
    //     next((vm) => {
    //         if (vm.$common.checkToken(vm.token)) {
    //             vm.$http.set_anchor(9, vm.token)
    //         }
    //     })
    // },
    created() {
        // setEndTime('2024-02-28 23:59:59');
        this.is_pc = this.$common.isMobile() ? 0 : 1
        this.requireToken()
    },
    methods: {
        // 权限判断
        requireToken() {
            if (this.$route.query.token) {
                this.token = this.$route.query.token
                this.init()
            } else if (!this.$common.isMobile()) {
                // pc端
                $.ajax({
                    url: base_url + '/getcookiejs',
                    dataType: 'jsonp',
                    cache: false,
                    async: false,
                    jsonp: 'myCallBack',
                    success: (u) => {
                        if (u && u.id > 0) {
                            // console.log(u);
                            this.token = u.token
                            this.init()
                        }
                    },
                })
            } else {
                // 移动端
                if (this.$route.query.openid) {
                    this.$storage.setOpenId(this.$route.query.openid)
                    this.open_id = this.$route.query.openid
                    this.token = this.$storage.getToken() //本地缓存token
                    if (this.is_valid(this.token)) {
                        this.init()
                    } else {
                        //token过期
                        this.query_sign_info()
                    }
                } else {
                    window.location.replace(base_url + '/GetWxOpenidV1')
                }
            }
        },
        // 获取token权限
        getPermission() {
            if (this.open_id && this.is_sign) {
                // 微信端已报名
                this.pop_show = 'apply'
                this.query_sign_info();
            } else {
                if (!this.$common.isMobile()) {
                    // pc端
                    if (this.is_valid(this.token)) {
                        if(this.is_sign){
                            this.pop_show = 'apply'
                        }else{
                            return false
                        }
                        // this.pop_show = this.is_sign?'apply':'role'
                        if(this.is_sign){this.query_sign_info()}
                    } else {
                        window.location.href =
                            'https://www.09game.com/html/usercenter2020/login.html?returnurl=' + encodeURIComponent(this.removeUrlParams(window.location.href))
                    }
                } else {
                    // 移动端
                    this.token = this.$storage.getToken() //本地缓存token 注释
                    if (this.is_valid(this.token)) {
                        if(this.is_sign){
                            this.pop_show = 'apply'
                        }else{
                            return false
                        }
                        // this.pop_show = this.is_sign?'apply':'role'
                        if(this.is_sign){this.query_sign_info()}
                    } else {
                        //token过期
                        this.get_auth()
                    }
                }
            }
        },
        removeUrlParams(url) {
           const paramsIndex = url.indexOf('?');
            if (paramsIndex > -1) {
                const baseUrl = url.substring(0, paramsIndex);
                return baseUrl;
            }
            return url
        },
        //检验token是否在有效期内
        is_valid(Ucookie) {
            if (Ucookie != null) {
                var now = new Date().getTime()
                if (now >= Ucookie.split('-')[3] * 1000) {
                    //token过期
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        },

        agreeFunc(){
            if(this.is_sign) {
                return false
            }
            if(this.is_agree === false){
                this.$message.error('请点击阅读并同意《09平台龙虎杯参赛者协议》！')
                return false
            }
            this.is_agree = !this.is_agree
        },

        // 查询报名记录
        query_sign_info() {
            let _this = this
            this.$http
                .q_hd('GetSignUpLog', hd_url, {
                    token: this.token,
                    open_id: this.open_id,
                })
                .then((res) => {
                    if (res.code == 0 && res.msg) {
                        // 已报名
                        let data = res.msg
                        this.role = data.type
                        this.phone = data.phone
                        this.email = data.email
                        this.psw = data.password
                        this.team_name = data.team_name
                        this.game_name = data.game_name
                        this.teams = data.teams
                        this.map_type = data.map_type?data.map_type:0
                        this.is_sign = true
                    } else {
                        this.is_sign = false
                    }
                })
        },
        log_out() {
            if (this.token) {
                $.ajax({
                    url: base_url + '/UserHttpLoginOut',
                    dataType: 'jsonp',
                    async: false,
                    jsonp: 'loginOut',
                    success: (res) => {
                        if (res.result == 0) {
                            window.location.href =
                                'https://www.09game.com/html/usercenter2020/login.html?returnurl=' +
                               encodeURIComponent(this.removeUrlParams(window.location.href))
                        }
                    },
                })
            }
        },
        // 解散队伍
        dismiss(){
            if(!this.is_sign){return false}
            this.$confirm('你即将解散当前报名的队伍', '是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => { 
                if(this.btn_lock) {return false}
                this.btn_lock = true;
                 this.$http
                .q_hd('Dissolve', hd_url, {
                    token: this.token,
                    openid: this.open_id,
                })
                .then((res) => {
                    if (res.code == 0) {
                        // 操作成功
                        this.btn_lock = false
                        this.$message({ type: 'success', message: '队伍解散成功！'});
                        this.pop_show = ''
                        this.query_sign_info();
                    } else {
                        this.btn_lock = false
                        this.$message({ type: 'error', message: res.error?res.error:'队伍解散失败！'});
                    }
                })
               
            }).catch(() => {
                // this.$message({ type: 'info', message: '已取消操作', showClose: true });
            });
        },
        // 移除队员
        removePlayer(item){
            this.$confirm('确定移除队员“' + item.game_name + '”吗？', '是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => { 
                if(this.btn_lock) {return false}
                this.btn_lock = true;
                 this.$http
                .q_hd('DelTeamUser', hd_url, {
                    token: this.token,
                    log_id: item.log_id,
                    openid: this.open_id,
                })
                .then((res) => {
                    if (res.code == 0) {
                        // 操作成功
                        this.btn_lock = false
                        this.$message({ type: 'success', message: '队员移除成功！'});
                        this.query_sign_info();
                    } else {
                        this.btn_lock = false
                        this.$message({ type: 'error', message: res.error?res.error:'移除失败！'});
                    }
                })
               
            }).catch(() => {
                // this.$message({ type: 'info', message: '已取消操作', showClose: true });
            });
        },
        // 修改队伍密码
        changePsw(){
            this.$prompt('确定修改队伍密码为：', '是否继续？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^\d{4}$/,
                inputErrorMessage: '密码需为4位数字！'
            }).then(({value}) => {
               if(this.btn_lock) {return false}
                this.btn_lock = true;
                 this.$http
                .q_hd('UpdPass', hd_url, {
                    token: this.token,
                    password: value,
                    openid: this.open_id,
                })
                .then((res) => {
                    if (res.code == 0) {
                        // 操作成功
                        this.btn_lock = false
                        this.$message({ type: 'success', message: '密码修改成功！'});
                        this.query_sign_info();
                    } else {
                        this.btn_lock = false
                        this.$message({ type: 'error', message: res.error?res.error:'修改失败！'});
                    }
                })
            })
        },
        // 提交
        submit() {
            let text = ''
            let element = '.pop.apply .submit-btn'
            if (this.btn_lock) {
                return false
            }
            if (this.is_sign) {
                return false
            }
            this.phone = this.phone.trim()
            this.email = this.email.trim()
            this.team_name = this.team_name.trim()

            if (!this.checkPhone(this.phone)) {
                return false
            }
            if (!this.checkEmail(this.email)) {
                return false
            }

            if(this.role == 1 && !this.map_type){
                this.$message.error('请选择比赛项目类型！')
                return false
            }

            if (!this.checkNickname(this.team_name, 2)) {
                return false
            }
             if (!this.checkPassword(this.psw)) {
                return false
            }
         
            if (!this.is_agree) {
                this.$message.error('请阅读并同意 《09平台龙虎杯参赛者协议》')
                return false
            }
            this.btn_lock = true

            this.$http
                .q_hd('SignUp', hd_url, {
                    token: this.token,
                    game_name: this.game_name,
                    phone: this.phone,
                    email: this.email,
                    type: this.role,
                    password: this.psw,
                    team_name: this.team_name,
                    map_type: this.role == 1? this.map_type: 0,
                }, true).then((res) => {
                    if (res.code == 0) {
                        //提交成功
                        this.is_sign = true
                        this.btn_lock = false
                        this.pop_show = ''
                        this.$message({
                            message: '报名成功！',
                            type: 'success',
                        })
                        this.query_sign_info();
                    } else {
                        this.btn_lock = false
                        this.err = res.msg ? res.msg : res.error ? res.error : '提交失败，请联系管理员！'
                        // this.mate_show(element, text, -40)
                    }
                })
        },

        // 查询我的道具数量
        query_my_item(id) {
            var _this = this
            var amount = 0
            $.ajax({
                url: shop_url + JSON.stringify({ type: 'q_my_item', json: JSON.stringify({ item_id: id, token: this.token }) }),
                async: false,
                success: (res) => {
                    if (res.code == 0) {
                        amount = res.records[0].amount
                    }
                },
            })
            return amount
        },
        isRepeat(arr) {
            var hash = {};
            for (var i in arr) {
                if (hash[arr[i]]){
                    return true; 
                }
                hash[arr[i]] = true;
            }
            return false;
        },
        close_pop() {
            if (this.pop_show == 'c_reward') {
                this.choose_id = -1
                this.choose_opt = -1
                this.choose_item = null
            } else if (this.pop_show == 'toast') {
                this.prize = ''
                if (this.step_now != 6) {
                    this.current_index -= this.step_now
                    this.goBack()
                } else {
                    this.btn_lock = false
                    this.query_my_packet()
                }
            }
            this.pop_show = ''
            this.err = ''
        },

        // requireToken() {
        //     var Ucookie = this.token
        //     if (Ucookie != null) {
        //         var now = new Date().getTime()
        //         if (now >= Ucookie.split('-')[3] * 1000) {
        //             //token过期
        //             this.get_auth()
        //         } else {
        //             this.init()
        //         }
        //     } else {
        //         this.get_auth()
        //     }
        // },
        get_auth() {
            window.location.replace(base_url + '/GetWxOpenid?fromPage=dt_cup')
        },
        async init() {
            // this.token = this.$storage.getToken()
            this.user_id = this.token.split('-')[0]
            await this.$http.getUserInfo(this.token).then((res) => {
                if (res.result == 0 && res.temp) {
                    this.user_info = Object.assign({}, this.user_info, res.temp)
                    this.$storage.setUserId(this.user_info.user_id)
                    this.$storage.setUserName(this.user_info.name)
                    this.$storage.setHeadId(this.user_info.avtar_head)
                    this.$storage.setUserLevel(this.user_info.level)
                    this.$storage.setUserFlag(this.user_info.flag)
                    this.user_id = this.user_info.user_id
                    this.user_name = this.user_info.name

                    this.game_name = this.user_name;
        this.phone = this.user_info.moile
        this.email = this.user_info.email
                }
            })
            // this.$http.getAllUser(this.token).then((res) => {
            //     if (res.result == 0 && res.msg && res.msg.length > 0) {
            //         this.account_list = res.msg
            //         this.$storage.setAccountList(JSON.stringify(res.msg))
            //     } else {
            //         this.account_list = []
            //     }
            // })
            this.query_sign_info()
        },

        checkPassword(psw){
            this.err = ''
            let Regex = /^\d{4}$/
            if (!Regex.test(psw)) {
                this.err = '请填写4位数字密码！'
                return false
            }
            return true
        },

        // 校验名称
        checkNickname(name, type) {
            let btn_name =
                type == 1
                    ? '队长昵称'
                    : type == 2
                    ? '队伍名称'
                    : type == 3
                    ? '队员1昵称'
                    : type == 4
                    ? '队员2昵称'
                    : type == 5
                    ? '队员3昵称'
                    : type == 6
                    ? '队员4昵称'
                    : type == 7
                    ? '队员5昵称'
                    : '内容'
            this.err = ''
            name = name.trim()
            if (name == '' && type != 7) {
                this.err = btn_name + '不能为空'
                return false
            }
            var totalLength = 0
            /* 计算utf-8编码情况下的字符串长度 */
            // for (let i = 0; i < name.length; i++) {
            //     if (name.charCodeAt(i) <= parseInt('0x7F')) {
            //         totalLength += 1
            //     } else if (name.charCodeAt(i) <= parseInt('0x7FF')) {
            //         totalLength += 2
            //     } else if (name.charCodeAt(i) <= parseInt('0xFFFF')) {
            //         totalLength += 3
            //     } else if (name.charCodeAt(i) <= parseInt('0x1FFFFF')) {
            //         totalLength += 4
            //     } else if (name.charCodeAt(i) <= parseInt('0x3FFFFFF')) {
            //         totalLength += 5
            //     } else {
            //         totalLength += 6
            //     }
            // }
            totalLength = name.length
            if (totalLength > 10) {
                this.err = btn_name + '超过最大字符长度！'
                return false
            }

            let flag = true
            if (type == 1 || type == 3 || type == 4 || type == 5 || type == 6 || (type == 7 && name !== '')) {
                $.ajax({
                    url: base_url + '/GetNameExist?user_name=' + name,
                    async: false,
                    success: (res) => {
                        if (res.code == 0) {
                            flag = false
                            this.err = btn_name + '不存在！'
                        } else if (res.code == 3) {
                            flag = false
                            this.err = btn_name + '不合法！'
                        } else {
                            this.err = ''
                        }
                    },
                })
            }
            return flag
        },
        // 校验邮箱号码
        checkEmail(email) {
            // console.log('进了校验邮箱的func……')
            this.err = ''
            let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!emailRegex.test(email)) {
                this.err = '请填写正确的邮箱！'
                return false
            }
            return true
        },

        // 校验手机号格式
        checkPhone(phone) {
            this.err = ''
            phone = phone.trim()
            if (phone == '') {
                this.err = '请填写手机号！'
                return false
            }
            if (phone.length != 11 || !/^1[3456789][0-9]{9}$/.test(phone)) {
                this.err = '请填写正确的手机号！'
                return false
            }
            return true
        },
        mate_show(element, text, offsetTop, offsetLeft = 5) {
            $('.mate-info').html(text)
            var width1 = $(element).width()
            var width = $('.mate-info').width() + 44
            var offWidth = (width1 - width) / 2
            var top = $('.content').offset().top
            var cssTop = $(element).offset().top - top + offsetTop
            var cssLeft = $(element).offset().left + offWidth + offsetLeft
            var css = {
                top: cssTop,
                left: cssLeft,
            }
            if (this.timer) {
                clearTimeout(this.timer)
            }
            $('.mate-info').show().css(css)
            this.timer = setTimeout(function () {
                $('.mate-info').hide().html('')
            }, 3000)
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/dt_cup/index.scss';
</style>

<style scoped>
.dtcup-main /deep/ .input-box {
    width: 5.1rem;
    height: 0.48rem;
    line-height: 0.48rem;
    background: #031535;
    border: 0.01rem solid #5576bb;
    border-radius: 0;
    margin-top: 0.12rem;
}
.dtcup-main /deep/ .input-box .title {
    color: #587cb8 !important;
    font-size: 0.22rem !important;
}
.dtcup-main /deep/ .input-box input {
    color: #b8d2ff !important;
    font-size: 0.22rem !important;
    opacity: 1;
}
.dtcup-main /deep/ .input-box.own input {
    color: #ffd800 !important;
    font-size: 0.22rem !important;
    opacity: 1;
}
.dtcup-main /deep/ .input-box input::placeholder {
    color: #354d77;
}
</style>
<style  lang="scss">
.el-message-box{
    width: 350px!important;
}
</style>


// WEBPACK FOOTER //
// src/view/dt_cup.vue